/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsHolderDetailConfig } from '../../config/settings.config';
export interface IsettingsHolderDetailPluginMethods extends IPluginMethodMap {
  getsettingsHolderDetailSync(args?: any): any;
}

export class settingsHolderDetailPlugin implements IAgentPlugin {
  readonly methods: IsettingsHolderDetailPluginMethods;

  constructor() {
    this.methods = {
      getsettingsHolderDetailSync: this.getsettingsHolderDetailSync.bind(this),
    };
  }

  getsettingsHolderDetailSync(args?: any) {
    return {
      setting: settingsHolderDetailConfig,
    };
  }
}
